import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { ICM_URL } from "@ane/exp-data/lib/constants/LinkConstants";
const VPN_ERROR_MESSAGES = {
  title: "VPN Required",
  errorMessage: "Azure ExP now requires an allowed network. Please connect a VPN and refresh this page.",
  instructionMessage: "Most users should use Azure VPN (MSFT-AzVPN-*) or access from Corpnet, a SAW, or a cloud Dev Box.",
  docURL: "https://aka.ms/vpn",
  VpnErrorCode: 403,
  VpnErrorMessage: "Please turn on MSFT-AzVPN-Manual!"
};
const getVpnErrorMessage = () => /* @__PURE__ */ jsxs(Fragment, { children: [
  /* @__PURE__ */ jsx("p", { children: VPN_ERROR_MESSAGES.errorMessage }),
  /* @__PURE__ */ jsx("p", { children: VPN_ERROR_MESSAGES.instructionMessage }),
  /* @__PURE__ */ jsxs("p", { children: [
    "Please visit",
    " ",
    /* @__PURE__ */ jsx("a", { href: VPN_ERROR_MESSAGES.docURL, target: "_blank", rel: "noopener noreferrer", children: "aka.ms/vpn" }),
    " ",
    "for details including other cases."
  ] }),
  /* @__PURE__ */ jsxs("p", { children: [
    /* @__PURE__ */ jsx("a", { href: ICM_URL, target: "_blank", rel: "noopener noreferrer", children: /* @__PURE__ */ jsx("b", { children: "File an IcM incident" }) }),
    "."
  ] })
] });
export {
  VPN_ERROR_MESSAGES,
  getVpnErrorMessage
};
//# sourceMappingURL=VpnError.constants.js.map
